export type NavRoute = {
  name: string;
  hash?: string;
  value: string;
  labelKey: string;
};

export const homeRoute: NavRoute = {
  name: "home",
  hash: "#home",
  value: "Strona Główna",
  labelKey: "nav.home",
};

export const aboutRoute: NavRoute = {
  name: "home",
  hash: "#about",
  value: "O nas",
  labelKey: "nav.about",
};

export const faqRoute: NavRoute = {
  name: "home",
  hash: "#faq",
  value: "FAQ",
  labelKey: "nav.faq",
};

export const contactRoute: NavRoute = {
  name: "home",
  hash: "#contact",
  value: "Kontakt",
  labelKey: "nav.contact",
};

export const orderRoute: NavRoute = {
  name: "order",
  value: "Zamów Teraz",
  labelKey: "nav.order",
};

export const orderStatusRoute: NavRoute = {
  name: "orderStatus",
  value: "Status zamówienia",
  labelKey: "nav.orderStatus",
};

export const termsRoute: NavRoute = {
  name: "terms",
  value: "Regulamin",
  labelKey: "nav.terms",
};

export const privacyRoute: NavRoute = {
  name: "privacy",
  value: "Polityka Prywatności",
  labelKey: "nav.privacy",
};

export const deliveryRoute: NavRoute = {
  name: "deliveries",
  value: "Informacje o dostawach",
  labelKey: "nav.delivery",
};

export const navRoutes = [homeRoute, aboutRoute, faqRoute, contactRoute];
export const termsRoutes = [termsRoute, privacyRoute, deliveryRoute];
